<template>
  <div>
    <!-- Backdrop
    <div v-if="show" class="offcanvas-backdrop fade d-lg-none" @click="handleClose" aria-hidden="true"></div> -->

    <!-- Bottom Drawer -->
    <div
      class="offcanvas offcanvas-bottom d-lg-none"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="show ? 'mobile-drawer-title' : null"
      style="height: 45vh; visibility: visible"
    >
      <div class="p-3 d-flex justify-content-between align-items-center">
        <h3 id="mobile-drawer-title" class="mb-0 h4">{{ title }}</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close selection drawer"
          @click="handleClose"
        ></button>
      </div>
      <div
        ref="scrollableContent"
        class="px-3 pb-3 overflow-auto"
        style="max-height: calc(45vh - 56px)"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileSelectionOffcanvas",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["close"],
  watch: {
    title() {
      // Scroll to top when title changes (which happens when selection changes)
      this.scrollToTop();
    },
    show(newVal) {
      // Scroll to top when offcanvas is shown
      if (newVal) {
        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    scrollToTop() {
      // Scroll the scrollable content area to the top
      if (this.$refs.scrollableContent) {
        this.$refs.scrollableContent.scrollTop = 0;
      }
    }
  }
};
</script>

<style scoped>
/* Rely on Bootstrap's offcanvas styles; we toggle with Vue instead of JS */
/* Increase z-index to be above Bootstrap tooltips (1080) */
.offcanvas {
  z-index: 1090 !important;
}
</style>
